import CloudFileIcon from "./index.vue";
import { inject } from "vue";

export interface IconMap {
  [propsName: string]: string;
}

const fileIconKey = Symbol();

const fileIconMap: IconMap = {};

const componentPlugin = {
  install(vue) {
    const ctx = require.context("@/assets/images", false, /.*cloud-file-.*/);

    ctx.keys().forEach((path) => {
      const temp = path.match(/cloud-file-([a-z1-9]+)\.[a-z]+$/);
      if (!temp) return;
      const name = temp[1];
      const fileName = temp[0].slice(0, -4);

      if (process.env.isVite) {
        fileIconMap[name] = new URL(`/src/assets/images/${fileName}.png`, import.meta.url).href;
      } else {
        fileIconMap[name] = require(`@/assets/images/${fileName}.png`);
      }
    });

    vue.provide(fileIconKey, fileIconMap);
    vue.component(CloudFileIcon.name, CloudFileIcon);
  },
};

export default componentPlugin;

export const useFileIcon = () => {
  return inject<IconMap>(fileIconKey);
};
